module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-container"
  }, [_c('el-row', {
    staticClass: "headTop"
  }, [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    staticClass: "goBack",
    staticStyle: {
      "width": "150px"
    },
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }, [_vm._v("返回上一级")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2,
      "offset": 20
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "success",
      "icon": "el-icon-circle-plus-outline"
    },
    on: {
      "click": function($event) {
        return _vm.showDialog()
      }
    }
  }, [_vm._v("新增")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "退票配置",
      "visible": _vm.dialogVisible,
      "width": "1000px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "formparams",
    attrs: {
      "model": _vm.formparams,
      "rules": _vm.rules,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "退票时间类型",
      "prop": "cancleTimeType"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formparams.cancleTimeType),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "cancleTimeType", $$v)
      },
      expression: "formparams.cancleTimeType"
    }
  }, _vm._l((this.timetypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.lable,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "退票时长",
      "prop": "canceltime"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入取消预约时长"
    },
    model: {
      value: (_vm.formparams.canceltime),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "canceltime", _vm._n($$v))
      },
      expression: "formparams.canceltime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否审批"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": "1",
      "inactive-value": "0",
      "active-text": "是",
      "inactive-text": "否"
    },
    model: {
      value: (_vm.formparams.ifApprove),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "ifApprove", $$v)
      },
      expression: "formparams.ifApprove"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "退款百分比",
      "prop": "refundPercentage"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "maxlength": "3",
      "placeholder": "请输入退款百分比(1-100)"
    },
    model: {
      value: (_vm.formparams.refundPercentage),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "refundPercentage", _vm._n($$v))
      },
      expression: "formparams.refundPercentage"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('formparams')
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('formparams')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "tableList"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.tableData,
      "height": "73vh",
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "票名称"
    }
  }, [
    [_c('div', [_vm._v(_vm._s(_vm.name) + " ")])]
  ], 2), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "取消预约时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_c('span', [_vm._v(_vm._s(scope.row.canceltime))]), _vm._v(" "), (scope.row.cancleTimeType == 0) ? _c('span', [_vm._v("天")]) : _vm._e(), _vm._v(" "), (scope.row.cancleTimeType == 1) ? _c('span', [_vm._v("小时")]) : _vm._e(), _vm._v(" "), (scope.row.cancleTimeType == 2) ? _c('span', [_vm._v("分钟")]) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "场馆"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(" " + _vm._s(_vm._f("caseType")(scope.row.shopnum)) + " ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "退款百分比"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(" " + _vm._s(scope.row.refundPercentage) + " ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticStyle: {
            "width": "100px"
          },
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "width": "100px"
          },
          attrs: {
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.remove(scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "pageination",
    staticStyle: {
      "display": "none"
    }
  }, [_c('el-col', [_c('el-pagination', {
    staticStyle: {
      "textAlign": "center",
      "marginTop": "10px"
    },
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [20, 40, 80, 100],
      "page-size": 20,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": this.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-f0b2fe00"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/buyTicket/backticket.vue
// module id = 629
// module chunks = 70